export const LOAD_APPLICATIONS = '@APPLIST/LOAD_APPLICATIONS'
export const LOAD_APPLICATIONS_SUCCESS = '@APPLIST/LOAD_APPLICATIONS_SUCCESS'
export const CREATE_APPLICATION_REQUEST = '@APPLIST/CREATE_APPLICATION_REQUEST'
export const SET_CREATE_APPLICATION_LOADING = '@APPLIST/SET_CREATE_APPLICATION_LOADING'
export const REQUEST_DELETE_APPLICATION = '@APPLIST/REQUEST_DELETE_APPLICATION'
